import { useState } from "react";
import PropTypes from "prop-types";
import OptionToggler from "../../../../parts/OptionToggler";
import { LinkPushCommunityComponent } from "./LinkPushCommunityComponent";
import ToolTip from "../../../../parts/tooltip";

export const PushCommunityCardActionsComponent = ({
  pushAccountInfo,
  communityLinkFromDb,
  useLink,
  option,
  tooltip,
}) => {
  const {
    inAppCommunityEnabled: inAppCommunityEnabledFromDb = false,
    externalCommunityEnabled: externalCommunityEnabledFromDb = false,
  } = pushAccountInfo;
  const initialState = {
    inAppCommunityEnabled: inAppCommunityEnabledFromDb,
    externalCommunityEnabled: externalCommunityEnabledFromDb,
    communityLink: communityLinkFromDb,
  };

  const [state, setState] = useState(initialState);

  const { inAppCommunityEnabled, externalCommunityEnabled, communityLink } =
    state;

  const pushCommunityOptions = [
    { label: "On", value: true },
    { label: "Off", value: false },
  ];

  /**
   * Function to update the state of the toggles
   * @param {*} option
   * @param {*} value
   */

  const setCommunityToggler = (option, value) => {
    setState({
      ...state,
      [option]: value,
    });
  };

  /**
   * Render the tooltip
   * @param {*} body
   * @returns
   */
  const renderCommunityTooltip = (body) => {
    return (
      <ToolTip
        id="community-tooltip"
        className="help-tooltip"
        body={body}
        multiline
      >
        <div className="help-tooltip-container">?</div>
      </ToolTip>
    );
  };

  /**
   * Function to update the state of the input
   * @param {*} {target}
   */
  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };

  return (
    <div className="push-community-card-actions">
      {useLink && externalCommunityEnabled && (
        <LinkPushCommunityComponent
          communityLink={communityLink}
          handleChange={handleChange}
        />
      )}
      <OptionToggler
        name={option}
        options={pushCommunityOptions}
        defaultValue={
          option === "inAppCommunityEnabled"
            ? inAppCommunityEnabled
            : externalCommunityEnabled
        }
        onSelectFn={(toggleValue) => {
          setCommunityToggler(option, toggleValue);
        }}
      />

      {renderCommunityTooltip(tooltip)}
    </div>
  );
};

PushCommunityCardActionsComponent.propTypes = {
  pushAccountInfo: PropTypes.object.isRequired,
  communityLinkFromDb: PropTypes.string,
  useLink: PropTypes.bool.isRequired,
  option: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};
